export const OTHER = '#6A6C7C';
export const NEUTRAL = '#E7E7E7';
export const TIE = '#666666';

// export const YES = '#73a8a7';
// export const NO = '#e9c368';
export const NEWSOM = '#a7c8e0';
export const SHELLENBERGER = '#BDB3CC';
export const SENUM = '#BDB3CC';
export const DAHLE = '#f9c0be';
export const COLLINS = '#f9c0be';
export const LE_ROUX = '#f9c0be';
export const WILLIAMS = '#f9c0be';

const colorLookup = new Map([
  // ['polid-2', YES],
  // ['polid-3', NO],
  ['polid-60374', NEWSOM],

  ['polid-66508', SHELLENBERGER], // NPP
  ['polid-70697', SENUM],

  ['polid-70689', DAHLE], //GOP
  ['polid-70687', COLLINS],
  ['polid-69777', LE_ROUX],
  ['polid-70702', WILLIAMS],
]);

export function getColor(/** @type {string} */ apId) {
  return colorLookup.get(apId) || OTHER;
}
